import { Component, OnInit, ViewChild } from '@angular/core';
import { WorkplanListComponent } from '../workplan-list/workplan-list.component';
import { BudgetComponent } from '../budget/budget.component';
import { BreakupBudgetComponent } from '../breakup-budget/breakup-budget.component';
import { FinancingComponent } from '../financing/financing.component';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'app-workplan',
  templateUrl: './workplan.component.html',
  styleUrls: ['./workplan.component.css'],
})
export class WorkplanComponent implements OnInit {
  @ViewChild('workplanComponent') workplanComponent!: WorkplanListComponent;
  @ViewChild('budgetComponent') budgetComponent!: BudgetComponent;
  @ViewChild('breakupBudgetComponent')
  breakupBudgetComponent!: BreakupBudgetComponent;
  @ViewChild('FinancingComponent') FinancingComponent!: FinancingComponent;
  constructor() {}
  ngOnInit(): void {}
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  navigateToTab(index: number): void {
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = index;
    }
  }
  onTabChange(index: number): void {
    if (index === 0) {
      this.workplanComponent.resetForm();
    } else if (index === 1) {
      this.budgetComponent.resetForm();
    } else if (index === 2) {
      this.breakupBudgetComponent.resetForm();
    } else if (index === 3) {
      this.FinancingComponent.resetForm();
    }
  }
}
